export default __webpack_public_path__ + "static/logo-e5d9d4e36acf0ab54696e79e1990731e.jpg";